export default __webpack_public_path__ + "static/media/my_location_black_24dp_on.ee012cb6.svg";